import { GetServerSideProps } from 'next';

import Layout from '@/components/layout/LayoutWrapper';
import UpsellLandingWrapper from '@/components/upsellLanding/UpsellLandingWrapper';
import { InitRequest } from '@/hooks/store';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const AnnualOfferPage = () => {
	return (
		<Layout pageName="annual_offer" title="Calm - Annual Offer">
			<UpsellLandingWrapper bgImg="/_n/images/landing-pages/annual-offer-bg.webp" />
		</Layout>
	);
};

export default AnnualOfferPage;

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(context, [InitRequest.DEVICE, InitRequest.PRICES], {});

	return {
		props: {
			initialState,
		},
	};
};
